import { render, staticRenderFns } from "./AccountSettingsSecurity.vue?vue&type=template&id=469be44a&scoped=true"
import script from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSettingsSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsSecurity.vue?vue&type=style&index=0&id=469be44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469be44a",
  null
  
)

export default component.exports